import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Archive = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.4167 43.75C9.27083 43.75 8.28993 43.342 7.47396 42.526C6.65799 41.7101 6.25 40.7292 6.25 39.5833V13.5417C6.25 13.0208 6.33681 12.5521 6.51042 12.1354C6.68403 11.7188 6.90972 11.3194 7.1875 10.9375L10.1042 7.39583C10.3819 7.01389 10.7292 6.72743 11.1458 6.53646C11.5625 6.34549 12.0139 6.25 12.5 6.25H37.5C37.9861 6.25 38.4375 6.34549 38.8542 6.53646C39.2708 6.72743 39.6181 7.01389 39.8958 7.39583L42.8125 10.9375C43.0903 11.3194 43.316 11.7188 43.4896 12.1354C43.6632 12.5521 43.75 13.0208 43.75 13.5417V39.5833C43.75 40.7292 43.342 41.7101 42.526 42.526C41.7101 43.342 40.7292 43.75 39.5833 43.75H10.4167ZM11.25 12.5H38.75L36.9792 10.4167H13.0208L11.25 12.5ZM10.4167 16.6667V39.5833H39.5833V16.6667H10.4167ZM25 37.5L33.3333 29.1667L30.4167 26.25L27.0833 29.5833V20.8333H22.9167V29.5833L19.5833 26.25L16.6667 29.1667L25 37.5Z"
        fill={color}
      />
    </svg>
  )
}
